import { createContext } from 'react';

export type Theme = 'blueLight';

export interface ThemeContextProps {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextProps>({
  theme: 'blueLight',
  setTheme: () => {},
});

export const LOCALSTORAGE_THEME_KEY = 'app_theme';
